import PropTypes from 'prop-types';
import cx from 'classnames';
import { Icon } from '@bwoty-web/styleguide';
import './desktopArrowButton.scss';

const DesktopArrowButton = ({
  className,
  onClick,
  path,
  right,
  arrowGutters,
}) => {
  return (
    <button
      className={cx(
        'gw-desktop-horizontal-nav-button',
        { 'gw-desktop-horizontal-nav-button--extra-gutters': arrowGutters },
        { 'gw-desktop-horizontal-nav-button--right': right },
        className,
      )}
      type="button"
      onClick={onClick}
    >
      <Icon
        className="gw-desktop-horizontal-nav-button__icon"
        path={path}
        size="xs"
        sizeMobile="xs"
        aria-hidden="true"
      />
    </button>
  );
};
DesktopArrowButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  path: PropTypes.string.isRequired,
  right: PropTypes.bool,
  arrowGutters: PropTypes.bool,
};

DesktopArrowButton.defaultProps = {
  className: null,
  onClick: null,
  right: false,
  arrowGutters: false,
};

export default DesktopArrowButton;
